var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTimeZone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.996,
    viewBox: "0 0 16 16.996",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-zone",
    transform: "translate(-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29350",
    "data-name": "Group 29350",
    transform: "translate(25.025 11.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29349",
    "data-name": "Group 29349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48540",
    "data-name": "Path 48540",
    d: "M319.988,332a2.988,2.988,0,1,0,2.988,2.988A2.988,2.988,0,0,0,319.988,332Zm.5,2.988a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h.5v-.5a.5.5,0,1,1,1,0Z",
    transform: "translate(-317 -332)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29351",
    "data-name": "Group 29351",
    transform: "translate(15)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48541",
    "data-name": "Path 48541",
    d: "M254.5,138.228v2.324h3.311a14.087,14.087,0,0,0-.264-2.324Z",
    transform: "translate(-246.546 -133.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48542",
    "data-name": "Path 48542",
    d: "M140.124,338.228a9.113,9.113,0,0,0,.5,1.326,3.771,3.771,0,0,0,2.3,2.267v-3.593Z",
    transform: "translate(-135.971 -327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48543",
    "data-name": "Path 48543",
    d: "M257.3,3.593a9.117,9.117,0,0,0-.5-1.326A3.771,3.771,0,0,0,254.5,0V3.593Z",
    transform: "translate(-246.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48544",
    "data-name": "Path 48544",
    d: "M254.5,238.228v2.324h3.047a14.087,14.087,0,0,0,.264-2.324Z",
    transform: "translate(-246.546 -230.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48545",
    "data-name": "Path 48545",
    d: "M128.055,240.552v-2.324h-3.311a14.085,14.085,0,0,0,.264,2.324Z",
    transform: "translate(-121.101 -230.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48546",
    "data-name": "Path 48546",
    d: "M128.055,140.552v-2.324h-3.047a14.082,14.082,0,0,0-.264,2.324Z",
    transform: "translate(-121.101 -133.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48547",
    "data-name": "Path 48547",
    d: "M142.924,0a3.771,3.771,0,0,0-2.3,2.267,9.117,9.117,0,0,0-.5,1.326h2.8Z",
    transform: "translate(-135.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48548",
    "data-name": "Path 48548",
    d: "M17.893,138.228h-2.36A7.431,7.431,0,0,0,15,140.552h2.647A15.231,15.231,0,0,1,17.893,138.228Z",
    transform: "translate(-15 -133.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48549",
    "data-name": "Path 48549",
    d: "M17.647,238.228H15a7.431,7.431,0,0,0,.533,2.324h2.36A15.228,15.228,0,0,1,17.647,238.228Z",
    transform: "translate(-15 -230.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48550",
    "data-name": "Path 48550",
    d: "M48.732,16.973a7.028,7.028,0,0,1,.8-1.319,7.536,7.536,0,0,0-3.531,3.073H48.1A10.365,10.365,0,0,1,48.732,16.973Z",
    transform: "translate(-44.976 -15.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48551",
    "data-name": "Path 48551",
    d: "M47.148,339.692a7.459,7.459,0,0,0,2.39,1.609,7.03,7.03,0,0,1-.8-1.319,10.358,10.358,0,0,1-.637-1.754h-2.09a7.516,7.516,0,0,0,1.142,1.464Z",
    transform: "translate(-44.977 -327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48552",
    "data-name": "Path 48552",
    d: "M377.082,140.552h2.647a7.43,7.43,0,0,0-.533-2.324h-2.36A15.231,15.231,0,0,1,377.082,140.552Z",
    transform: "translate(-364.825 -133.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48553",
    "data-name": "Path 48553",
    d: "M329,17.263a7.459,7.459,0,0,0-2.39-1.609,7.029,7.029,0,0,1,.8,1.319,10.357,10.357,0,0,1,.637,1.754h2.09A7.518,7.518,0,0,0,329,17.263Z",
    transform: "translate(-316.263 -15.134)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48554",
    "data-name": "Path 48554",
    d: "M256.71,338.228H254.5v3.593a2.59,2.59,0,0,0,1.086-.58c0-.077-.007-.154-.007-.232A3.97,3.97,0,0,1,256.71,338.228Z",
    transform: "translate(-231.547 -327.001)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48555",
    "data-name": "Path 48555",
    d: "M379.532,240.552h.092a7.433,7.433,0,0,0,.533-2.324H377.51a15.272,15.272,0,0,1-.232,2.241,3.991,3.991,0,0,1,2.254.083Z",
    transform: "translate(-350.252 -230.32)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTimeZone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_time_zone.50f8ab981e9bbacaa83f7167cc5aab11.svg";